<template>
    <div>
        <title>{{ $t('reviews.text_1') }}</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
        <div class="title">
            <under-bar-name :title="$t('reviews.text_2')" :margin="false"></under-bar-name>
        </div>
        <div class="cont">
            <h1>{{ $t('reviews.text_3') }}</h1>
            <h3>{{ $t('reviews.text_4') }}</h3>
            <div class="main">
                <h2 class="nadpis">
                    {{ editReview ? $t('reviews.text_5') : $t('reviews.text_6') }}</h2>
                <create-edit-reviews 
                    :newReview="newReview"
                    :editReview="editReview"
                    :premium="premium"
                    @changeReview="newReview = $event"
                    @editReview="editReview = null"/>
            </div>
            <h2 v-if="premium" class="nadpis">{{ $t('reviews.text_7') }}</h2>
            <div v-if="premium" class="table-responsive" style="overflow-x: inherit;">
                <table-reviews 
                    :reviews="reviews"
                    :newReview="newReview"
                    @changeReview="newReview = $event"
                    @editReview="editReview = $event"/>
            </div>
        </div>
    </div>
</template>

<script>
import UnderBarName from '../../../layouts/Header/UnderBarName.vue'
import CreateEditReviews from './components/CreateEditReviews.vue'
import TableReviews from './components/TableReviews.vue'
export default {
    components: { TableReviews, CreateEditReviews, UnderBarName },
    props: ['reviews', 'premium'],
    data() {
        return {
            newReview: false,
            editReview: null
        }
    },
}
</script>

<style lang="scss" scoped>
    *{
        font-family: Roboto;
    }
    .error{
        width: 473px;
        height: 60px;
        margin: 15px auto;
        background: #FFEBEE;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 182.5%;
        color: #DB355F;
        svg{
            margin-right: 10px;
        }
    }   
    .title{
       width: 1188px;
       margin: 65px auto 0 auto;
       @media only screen and (max-width: 1500px) {
            width: 95%;
        }
    }
    .cont{
        width: 1188px;
        margin: 50px auto 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        padding: 57px 0 140px 0;
        @media only screen and (max-width: 1500px) {
            width: 95%;
        }            
        .nadpis{
            width: 474px;
            @media only screen and (max-width: 600px) {
                width: 90%;
                text-align: center;
            }
            margin: 0 auto 20px auto;
            text-align: center;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;
            color: #000000;
        }
        h1{
            @media only screen and (max-width: 600px) {
                width: 90%;
                margin: 0 auto;
            }
            font-style: normal;
            font-weight: bold;
            font-size: 36px;
            line-height: 42px;
            text-align: center;
            color: #2e0808;
        }
        h3{
            width: 740px;
            @media only screen and (max-width: 600px) {
                width: 90%;
            }
            margin: 23px auto 36px auto;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            color: #9598A7;
        }
        .main{
            width: 1030px;
            margin: 0 auto;
            background: #F2F7FB;
            border-radius: 5px;
            padding: 30px 0 50px 0;
            margin-bottom: 50px;
            @media only screen and (max-width: 1500px) {
                width: 90%;
            }
            .nadpis{
                width: 474px;
                @media only screen and (max-width: 600px) {
                    width: 90%;
                    text-align: center;
                }
                margin: 0 auto 20px auto;
                text-align: center;
                font-style: normal;
                font-weight: bold;
                font-size: 24px;
                line-height: 28px;
                color: #000000;
            }
            .ulozit{
                width: 474px;
                @media only screen and (max-width: 600px) {
                    width: 90%;
                }
                height: 55px;
                margin: 37px auto 75px auto;
                background: #2ED8B6;
                border-radius: 4px;

                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
                color: #FFFFFF;
                cursor: pointer;
                transition: .5s all;
                &:hover{
                    background: #23caa9;
                }
            }
        }
    }
</style>